import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import VaulzoLogo from "./VaulzoLogo";

const nav = [
  { href: "#features", label: "Features" },
  { href: "#how", label: "How it works" },
  { href: "#faq", label: "FAQ" },
];

/**
 * Sticky landing header. Mirrors the dashboard header (same height,
 * blurred bar, hairline border, logo) with marketing nav + auth CTAs.
 */
export default function LandingHeader({ onOpenAuth }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-20 border-b border-vaulzo-hairline bg-[rgba(250,250,249,0.82)] backdrop-blur-[14px]">
      <div className="mx-auto flex h-[66px] max-w-[800px] items-center gap-4 px-6">
        <Link to="/" className="flex min-w-0 flex-1 items-center">
          <VaulzoLogo />
        </Link>

        {/* Section links (desktop only) */}
        <nav className="hidden flex-none items-center gap-[clamp(18px,3vw,38px)] md:flex">
          {nav.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-sm text-vaulzo-faint transition-colors hover:text-vaulzo-ink"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* Single door: signing in and signing up start the same way */}
        <div className="flex flex-1 items-center justify-end gap-3">
          <button
            type="button"
            onClick={() => onOpenAuth()}
            className="rounded-lg bg-vaulzo-accent px-[15px] py-[8px] text-[13px] font-semibold text-white transition-colors hover:bg-vaulzo-accent-hover"
          >
            Open Vaulzo
          </button>
          <button
            type="button"
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
            onClick={() => setMobileOpen((o) => !o)}
            className="flex h-9 w-9 items-center justify-center rounded-lg text-vaulzo-faint transition-colors hover:text-vaulzo-ink md:hidden"
          >
            {mobileOpen ? (
              <X className="h-5 w-5" strokeWidth={1.7} />
            ) : (
              <Menu className="h-5 w-5" strokeWidth={1.7} />
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="border-t border-vaulzo-hairline bg-vaulzo-bg px-6 py-4 animate-vz-fade md:hidden">
          {/* Section links only — the header's Open Vaulzo button stays visible on mobile */}
          <nav className="flex flex-col">
            {nav.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="border-b border-vaulzo-hairline py-3 text-sm text-vaulzo-muted transition-colors last:border-b-0 hover:text-vaulzo-ink"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
